export class SourceClassifier {
  id: number;
  title: string;
  code: string;
  upperSourceCode: string;
  source: string;
  sourceCode: string;
  validTo: Date;
}
